import type { PincodeApiResponse, PostOffice } from '@billx/types';

export class PincodeService {
  /**
   * Fetches pincode data from the API
   * @param pincode - The pincode to lookup
   * @returns Promise with the API response or null if invalid/error
   */
  static async fetchPincodeData(pincode: string): Promise<PostOffice | null> {
    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pincode}`
      );

      if (!response.ok) {
        return null;
      }

      const data: PincodeApiResponse[] = await response.json();

      // Check if we have valid data
      if (
        data &&
        data.length > 0 &&
        data[0].Status === 'Success' &&
        data[0].PostOffice &&
        data[0].PostOffice.length > 0
      ) {
        return data[0].PostOffice[0];
      }

      return null;
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      return null;
    }
  }
}
